import React from "react";
import { observer } from "mobx-react-lite";
import { INode } from "../../app/models/node";

interface IParams {
  selectedNode: INode;
  visible: boolean;
  meetingId: number;
}

const MeetingTreeSurveyContext: React.FC<IParams> = ({ selectedNode }) => {
  return (
    <>
      <div className="node-title">{selectedNode.title}</div>
      <div
        id={"cmd_" + selectedNode.key}
        className="treeCmdBox"
        style={{ display: "none" }}
      ></div>
    </>
  );
};

export default observer(MeetingTreeSurveyContext);
